import { CostAdditionalCodes } from './cost-additional-code.model';
import { CostType } from './cost-types.model';
import { ApprovalPath } from './approval-path.model';
import { Note } from './note.model';
import { Advance } from './advance.model';
import { Employee } from './employee.model';
import {ApprovalStep} from './approval-step.model';
import { CostHistory } from './cost-history.model';

export enum CostStatuses {
    New = 'new',
    InMeritoricalApproval = 'inMeritoricalApproval',
    InFormalApproval = 'inFormalApproval',
    InApproval = 'inApproval', // Can Approve / Reject
    Approved = 'approved', // Can Print
    Printed = 'printed', // Can Export
    Exported = 'exported',
    ReadyToReturn = 'readyToReturn', // Can Create Transfer Order
    Returned = 'returned', // Can Click to confirm payment
    Settled = 'settled', // Cost is fully settled
    Rejected = 'rejected',
    Canceled = 'canceled',
}

export class Cost {
    history: any;
    constructor(
        public id?: number,
        public name?: string,
        public additionalCodes?: CostAdditionalCodes[] | string[],
        public companyName?: string,
        public customer?: string,
        public description?: string,
        public detailedCode?: string,
        public docNumber?: string,
        public isDocumentElectronic?: boolean,
        public delegationNumber?: string,
        public employee?: Employee | number,
        public grossValue?: number,
        public isReinvoicing?: boolean,
        public machineModel?: string,
        public originalInvoiceName?: string,
        public pono?: string,
        public machineSerialNumber?: string,
        public type?: CostType | number,
        public createdBy?: Employee,
        public docDate?: string,
        public advance?: Advance | number,
        public approvalPath?: ApprovalPath,
        public approvalSteps?: ApprovalStep[],
        public createdAt?: string,
        public updatedAt?: string,
        public settledAt?: string,
        public forwardedToPaymentAt?: string,
        public notes?: Note[],
        public status?: CostStatuses | any,
        public canCurrentUserMakeAction?: boolean,
        public canRemove?: boolean,
        public removed?: boolean,
        public costHistory?: CostHistory[],
        public isKsef?: boolean,
        public ksefNumber?: string,
        public isConflictCase?: boolean,
        public blockedEmployeeId?: number
    ) { }

    static adapt(item: any): Cost {
        return new Cost(
            item.id,
            item.name,
            item.additionalCodes,
            item.companyName,
            item.customer,
            item.description,
            item.detailedCode,
            item.docNumber,
            item.isDocumentElectronic,
            item.delegationNumber,
            item.employee,
            item.grossValue,
            item.isReinvoicing,
            item.machineModel,
            item.originalInvoiceName,
            item.pono,
            item.machineSerialNumber,
            item.type,
            item.createdBy,
            item.docDate,
            item.advance,
            item.approvalPath,
            item.approvalSteps,
            item.createdAt,
            item.updatedAt,
            item.settledAt,
            item.forwardedToPaymentAt,
            item.notes ? item.notes.map(Note.adapt) : [],
            item.status,
            item.canCurrentUserMakeAction,
            item.canRemove,
            item.removed,
            item.costHistory,
            item.isKsef,
            item.ksefNumber,
            item.isConflictCase,
            item.blockedEmployeeId
        );
    }
}
